<template>
  <div>
    <chrome-picker
      v-if="showColorPicker && position === 'top'"
      v-model="localColor"
      :lazy="true"
      style="position: absolute; z-index: 1000; bottom: 105%"
    />
    <div class="color-picker-container" :style="{ width, height }" @click="toggleColorMode">
      <div
        class="color-picker-bar"
        :style="{
          backgroundColor: get_color_name(localColor),
          color: textColor,
          fontSize: fontSize
        }"
      >
        {{ text }}
      </div>
    </div>
    <chrome-picker
      v-if="showColorPicker && position === 'bottom'"
      v-model="localColor"
      :lazy="true"
      style="position: absolute; z-index: 1000"
    />
  </div>
</template>

<script>
import { Chrome } from 'vue-color';
import { get_color_name } from '@/components/util';

export default {
  name: 'CustomColorPicker',
  components: {
    'chrome-picker': Chrome
  },
  props: {
    disabled: { type: Boolean, default: false },
    value: { type: String, required: true, default: '#FFFFFF' }, // v-model을 위한 prop 이름은 'value'
    width: { type: String, default: '225px' },
    height: { type: String, default: '30px' },
    text: { type: String, default: '' },
    textColor: { type: String, default: 'white' },
    fontSize: { type: String, default: '20px' },
    position: { type: String, default: 'top' }
  },
  data() {
    return {
      showColorPicker: false,
      localColor: this.value || '#000000'
    };
  },
  watch: {
    localColor(newColor) {
      this.$emit('input', get_color_name(newColor));
    },
    value(newValue) {
      this.localColor = newValue || '#000000';
    },
    disabled(newValue) {
      if (newValue) {
        this.showColorPicker = false;
      }
    }
  },
  methods: {
    get_color_name,
    toggleColorMode() {
      if (!this.disabled) {
        this.showColorPicker = !this.showColorPicker;
      }
    }
  }
};
</script>
<style>
.color-picker-container {
  border: 1px solid #ccc;
  border-radius: 0.25rem;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  padding: 5px;
}

.color-picker-bar {
  width: 100%;
  height: 100%;
  border: 1px solid black;

  display: flex;
  justify-content: center;
  align-items: center;

  text-align: center;
  font-size: 14px;
}
</style>
